import { CommonActionTypes } from './common.types';

const setLoading = loading => ({
  type: CommonActionTypes.SET_LOADING,
  payload: {
    loading,
  },
});

const setNotifications = notifications => ({
  type: CommonActionTypes.SET_NOTIFICATIONS,
  payload: notifications,
});

const clearNotification = index => ({
  type: CommonActionTypes.CLEAR_NOTIFICATIONS,
  payload: { index },
});

const clearAllNotifications = () => ({
  type: CommonActionTypes.CLEAR_ALL_NOTIFICATIONS,
});

const setRedirect = redirect => ({
  type: CommonActionTypes.SET_REDIRECT,
  payload: {
    redirect,
  },
});

const clearRedirect = () => ({
  type: CommonActionTypes.CLEAR_REDIRECT,
});

const setServerTime = serverTime => ({
  type: CommonActionTypes.SET_SERVER_TIME,
  payload: {
    serverTime,
  },
});

const requestServerTime = () => ({
  type: CommonActionTypes.REQUEST_SERVER_TIME,
});

const setServerTimeLoading = serverTimeLoading => ({
  type: CommonActionTypes.SET_SERVER_TIME_LOADING,
  payload: {
    serverTimeLoading,
  },
});

const setToggles = toggles => ({
  type: CommonActionTypes.SET_TOGGLES,
  payload: toggles,
});

const requestPdfUrlByType = ({ pdfUrl, urlType }) => ({
  type: CommonActionTypes.REQUEST_PDF_URL_BY_TYPE,
  payload: {
    pdfUrl,
    urlType,
  },
});

const setPdfUrl = url => ({
  type: CommonActionTypes.SET_PDF_URL,
  payload: {
    url,
  },
});

const actions = {
  loading: {
    set: setLoading,
  },
  notifications: {
    set: setNotifications,
    remove: clearNotification,
    clearAll: clearAllNotifications,
  },
  redirect: {
    set: setRedirect,
    clear: clearRedirect,
  },
  serverTime: {
    set: setServerTime,
    request: requestServerTime,
    setLoading: setServerTimeLoading,
  },
  toggles: {
    set: setToggles,
  },
  pdf: {
    request: requestPdfUrlByType,
    set: setPdfUrl,
  },
};

export default actions;
